(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', (e) => {
    const mainArticleWrapper = document.querySelector('.main-article__wrapper');
    if (!mainArticleWrapper) return;
    const mainContent = mainArticleWrapper.closest('main#MainContent');

    if (mainArticleWrapper.querySelector('[style="color: #1e00ff;"]')) {
      mainArticleWrapper.querySelectorAll('[style="color: #1e00ff;"]').forEach((item) => {
        if (item.closest('p')) item.closest('p').classList.add('credit-line');
        else item.classList.add('credit-line');
      });
    }

    if (mainArticleWrapper.querySelector('.article-content__inner img')) {
      mainArticleWrapper.querySelectorAll('.article-content__inner img').forEach((img) => {
        let parentEl;
        if (img.parentElement.nextElementSibling || img.parentElement.previousElementSibling)
          parentEl = img.parentElement;
        else if (
          img.parentElement.parentElement.nextElementSibling ||
          img.parentElement.parentElement.previousElementSibling
        )
          parentEl = img.parentElement.parentElement;
        else if (
          img.parentElement.parentElement.parentElement.nextElementSibling ||
          img.parentElement.parentElement.parentElement.previousElementSibling
        )
          parentEl = img.parentElement.parentElement.parentElement;
        else parentEl = img;

        parentEl.classList.add('image-wrapper');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
